import {Syllabary} from "../WordFetcher";
import * as React from "react";
import {Modal} from "semantic-ui-react";
import Button from "semantic-ui-react/dist/commonjs/elements/Button";

interface IProps {
    open: boolean,
    syllabary: Syllabary,
    toggleFn(syllabary: Syllabary): void;
    resetStateFromStorage(): void;
}

interface IState {
}

export class ResetModal extends React.Component<IProps, IState> {
    readonly resetProgress = () => {
        if (this.props.syllabary == Syllabary.hiragana) {
            localStorage.removeItem('knownHiraganaCharacters');
            localStorage.removeItem('recentHiraganaHistory');
        } else {
            localStorage.removeItem('knownKatakanaCharacters');
            localStorage.removeItem('recentKatakanaHistory');
        }
        this.props.resetStateFromStorage();
        this.props.toggleFn(this.props.syllabary);
    };

    constructor(props: IProps) {
        super(props);
        this.state = {
            open: props.open,
        }
    }

    public render() {
        return (
            <Modal size="mini" open={this.props.open} onClose={() => this.props.toggleFn(this.props.syllabary)}>
                <Modal.Header>Delete Your Progress</Modal.Header>
                <Modal.Content>
                    <p>Are you sure you want to delete your {this.props.syllabary} progress?</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => this.props.toggleFn(this.props.syllabary)}>No</Button>
                    <Button icon='checkmark' labelPosition='right' content='Reset' onClick={this.resetProgress}/>
                </Modal.Actions>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ResetModal.tsx